/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { FC, useRef, useState } from 'react';
// import styled from 'styled-components';
import { usePersonaContext } from '../../../contexts/PersonaContext';
import Image from 'next/image';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import styles from './brandDictionary.module.css';
import { useAuthContext } from '../../../contexts/AuthContext';
import { replacementWords } from '../../../types/Persona.type';
import { FieldArray } from 'formik';
import { BasicButton } from '../../shared/buttons/BasicButton';
import { InfoButton } from '../../shared/buttons/InfoButton';
import Tooltip from '../../shared/tooltips/Tooltip';

const DropDownContainer = styled('div')`
  width: 100%;
  position: relative;
  display: flex;
  z-index: 1;
  flex-direction: column;
  padding: 0.5em 0.3em 0em 0em;
`;

const DropDownIcon = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 4;
  flex-direction: column;
`;

const DropDownHeader = styled('div')`
  width: 100%;
  cursor: pointer;
  margin-bottom: 0.4em;
  padding: 0.5em 0.5em 0.5em 0.5em;
  font-weight: 400;
  font-size: 1rem;
  color: black;
  font-family: Open Sans;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  mid-width: 30vw;
  display: flex;
  padding: 10px 20px;
  align-items: center;
`;

const DropDownListContainer = styled('div')`
  cursor: pointer;
  position: absolute;
  font-weight: 500;
  font-size: 1.3rem;
  color: #3faffa;
  background: white;
  border: 1.83px solid black;
  border-radius: 4px;
  width: 100%;
  margin-top: 50px;
  z-index: 5;
`;

const DropDownList = styled('ul')`
  padding: 0;
  margin: 0;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
`;

const ListItem = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.6em;
  padding-top: 0.6em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  font-family: Open Sans;
  display: flex;
  z-index: 500;
  mid-width: 30vw;
  justify-content: space-between;
  align-items: center;
  &: last-of-type {
    border-bottom: 0px;
  }

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

type Props = {
  brandReplacementWords?: replacementWords[];
  brandNoNoWords?: string[];
  brandUseSparinglyWords?: string[];
  updateBrandReplacementWords: (newValue: replacementWords[]) => void;
  updateBrandNoNoWords: (newValue: string[]) => void;
  updateBrandUseSparinglyWords: (newValue: string[]) => void;
};

export const BrandDictionary: FC<Props> = (prop) => {
  const { userData } = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Select rule type');
  const [noNoWordArray, setNoNoWordArray] = useState(
    prop.brandNoNoWords ?? ['']
  );
  const [noWordOption, setNoWordOption] = useState('');
  const [sparinglyArray, setSparinglyArray] = useState(
    prop.brandUseSparinglyWords ?? ['']
  );
  const [sparinglyOption, setSparinglyOption] = useState('');
  const [replacementArray, setReplacementArray] = useState(
    prop.brandReplacementWords ?? [{ replaceThis: '', withThis: '' }]
  );
  const [replaceOption1, setReplaceOption1] = useState('');
  const [replaceOption2, setReplaceOption2] = useState('');
  const SAfiltered = sparinglyArray.filter((item) => item !== '');
  const RAfiltered = replacementArray.filter((item) => item.replaceThis !== '');
  const NONOfiltered = noNoWordArray.filter((item) => item !== '');
  const menuRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  const toggling = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handler = (e: { target: any }) => {
      if (!menuRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });

  const onOptionClicked = (value: React.SetStateAction<string>) => () => {
    setSelectedOption(value);
    setIsOpen(false);
  };

  const handleNoNoChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setNoWordOption(e.target.value);
  };

  const handleSparinglyChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSparinglyOption(e.target.value);
  };

  const handleReplaceChange1 = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setReplaceOption1(e.target.value);
  };

  const handleReplaceChange2 = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setReplaceOption2(e.target.value);
  };

  const addToReplacementArray = () => {
    if (replaceOption1 !== '' && replaceOption2 !== '') {
      setLoading(true);
      setReplacementArray([
        ...replacementArray,
        { replaceThis: replaceOption2.trim(), withThis: replaceOption1.trim() },
      ]);
      prop.updateBrandReplacementWords([
        ...replacementArray,
        { replaceThis: replaceOption2.trim(), withThis: replaceOption1.trim() },
      ]);
      setReplaceOption1('');
      setReplaceOption2('');
      setLoading(false);
    }
  };

  const addToAvoidArray = () => {
    if (noWordOption !== '') {
      setLoading(true);
      setNoNoWordArray([...noNoWordArray, noWordOption.trim()]);
      prop.updateBrandNoNoWords([...noNoWordArray, noWordOption.trim()]);
      setNoWordOption('');
      setLoading(false);
    }
  };
  const addToSparinglyArray = () => {
    if (sparinglyOption !== '') {
      setLoading(true);
      setSparinglyArray([...sparinglyArray, sparinglyOption.trim()]);
      prop.updateBrandUseSparinglyWords([
        ...sparinglyArray,
        sparinglyOption.trim(),
      ]);
      setSparinglyOption('');
      setLoading(false);
    }
  };

  function removeFromArray(arr: string[], index: number) {
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  }

  function removeFromReplacementArray(arr: replacementWords[], index: number) {
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  }

  const handleSparinglyRemove = (index: number) => {
    const newArray = removeFromArray(sparinglyArray, index);
    setSparinglyArray(newArray);
  };

  const handleAvoidRemove = (index: number) => {
    const newArray = removeFromArray(noNoWordArray, index);
    setNoNoWordArray(newArray);
  };

  const handleReplacementRemove = (index: number) => {
    const newArray = removeFromReplacementArray(replacementArray, index);
    setReplacementArray(newArray);
  };

  return (
    <div className={styles['top']}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <h2 className={styles['flex-row2']}>Brand Dictionary</h2>
        <Tooltip
          tooltipText="Define key brand-specific terms and language for consistent messaging."
          style={{ marginRight: '530px' }}
        />
      </div>

      <DropDownContainer ref={menuRef}>
        <DropDownHeader onClick={toggling}>
          <div>{selectedOption ? selectedOption : 'Select rule type'}</div>

          <DropDownIcon>
            <Image
              src={'/icons/Arrow Chevron Down.svg'}
              alt="Close"
              layout="fixed"
              objectFit="contain"
              height={24}
              width={24}
              className={styles['image']}
            />
          </DropDownIcon>
        </DropDownHeader>
        {isOpen && (
          <DropDownListContainer>
            <DropDownList>
              <ListItem
                key="avoid"
                onClick={onOptionClicked('Avoid Saying')}
                value="Avoid Saying"
              >
                <div>
                  <div className={styles['label']}>
                    <b>Avoid Saying</b>
                  </div>
                  <div>
                    <p>Terms that are not okay to use.</p>
                  </div>
                </div>
              </ListItem>
              <ListItem
                key="replace"
                onClick={onOptionClicked('Say Instead')}
                value="Say Instead"
              >
                <div>
                  <div className={styles['label']}>
                    <b>Say Instead</b>
                  </div>
                  <div>
                    <p>Terms that over-rule other terms.</p>
                  </div>
                </div>
              </ListItem>
              <ListItem
                key="sparingly"
                onClick={onOptionClicked('Say Sparingly')}
                value="Say Sparingly"
              >
                <div>
                  <div className={styles['label']}>
                    <b>Say Sparingly</b>
                  </div>
                  <div>
                    <p>Terms that can be used in some contexts.</p>
                  </div>
                </div>
              </ListItem>
            </DropDownList>
          </DropDownListContainer>
        )}
        {selectedOption === 'Say Instead' && (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevents the default form submit action (page reload)
              addToReplacementArray();
            }}
          >
            <div className={styles['flex-row']}>
              <div className={styles['flex']}>
                <input
                  type="text"
                  placeholder="Say This"
                  name="additionalInfo"
                  value={replaceOption1}
                  onChange={handleReplaceChange1}
                  className={styles['add-info']}
                />
              </div>
              <div>
                <Image
                  src="/icons/GreaterThanSymbol.svg"
                  alt="instead of"
                  objectFit="contain"
                  height={16}
                  width={16}
                />
              </div>
              <div className={styles['flex']}>
                <input
                  type="text"
                  placeholder="Instead of This"
                  name="additionalInfo"
                  value={replaceOption2}
                  onChange={handleReplaceChange2}
                  className={styles['add-info']}
                />
              </div>
              <div>
                <BasicButton
                  theme="dark"
                  type="submit"
                  loading={loading}
                  disabled={
                    replaceOption2 === '' ||
                    replaceOption1 === '' ||
                    replaceOption1.trim() === '' ||
                    replaceOption2.trim() === ''
                  }
                  text="Save Rule"
                  onClick={() => {
                    addToReplacementArray();
                  }}
                  extraStyles={{
                    scale: '100%',
                    minWidth: '129px',
                    height: '42px',
                  }}
                />
              </div>
            </div>
          </form>
        )}
        {selectedOption === 'Avoid Saying' && (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevents the default form submit action (page reload)
              addToAvoidArray();
            }}
          >
            <div className={styles['flex-row']}>
              <div className={styles['flex']}>
                <input
                  type="text"
                  placeholder="Avoid saying"
                  name="additionalInfo"
                  value={noWordOption}
                  onChange={handleNoNoChange}
                  className={styles['add-info']}
                />
              </div>
              <div>
                <BasicButton
                  theme="dark"
                  type="submit"
                  loading={loading}
                  disabled={noWordOption === '' || noWordOption.trim() === ''}
                  onClick={() => {
                    addToAvoidArray();
                  }}
                  text="Save Rule"
                  extraStyles={{
                    scale: '100%',
                    minWidth: '129px',
                    height: '42px',
                  }}
                />
              </div>
            </div>
          </form>
        )}
        {selectedOption === 'Say Sparingly' && (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevents the default form submit action (page reload)
              addToSparinglyArray();
            }}
          >
            <div className={styles['flex-row']}>
              <div className={styles['flex']}>
                <input
                  type="text"
                  placeholder="Say Sparingly"
                  name="additionalInfo"
                  value={sparinglyOption}
                  onChange={handleSparinglyChange}
                  className={styles['add-info']}
                />
              </div>
              <div>
                <BasicButton
                  theme="dark"
                  type="submit"
                  loading={loading}
                  disabled={
                    sparinglyOption === '' || sparinglyOption.trim() === ''
                  }
                  text="Save Rule"
                  onClick={() => {
                    addToSparinglyArray();
                  }}
                  extraStyles={{
                    scale: '100%',
                    minWidth: '129px',
                    height: '42px',
                    zIndex: '0',
                  }}
                />
              </div>
            </div>
          </form>
        )}
      </DropDownContainer>
      {/* //start of buttons */}
      <div>
        <FieldArray
          name="avoid"
          render={(arrayHelpers) => {
            return (
              <div className={styles['container']}>
                {(NONOfiltered.length > 0 ||
                  RAfiltered.length > 0 ||
                  SAfiltered.length > 0) && (
                  <div className={styles['term-rules']}>
                    <h2>Term Rules</h2>
                  </div>
                )}
                <div className={styles['options-enter-container']}>
                  <div
                    aria-label="avoid-text-list"
                    className={styles['options-grid']}
                  >
                    {NONOfiltered?.map((text, index) => {
                      return (
                        <div
                          key={`$-${text || ''}-${index}`}
                          className={styles['no-no-option-container']}
                        >
                          <p>Avoid saying</p>
                          <b className={styles['option-text']}>{text}</b>
                          <button
                            type="button"
                            onClick={() => handleAvoidRemove(index)}
                            className={styles['avoid-button']}
                          >
                            <Image
                              src="/icons/CloseBlack.svg"
                              alt="delete"
                              objectFit="contain"
                              height={16}
                              width={16}
                            />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    aria-label="replace-text-list"
                    className={styles['options-grid']}
                  >
                    {RAfiltered?.map((text, index) => {
                      return (
                        <div
                          key={`$-${text.replaceThis || ''}-${index}`}
                          className={styles['replace-option-container']}
                        >
                          <p>Say</p>
                          <b>{text.withThis}</b>
                          <p>instead of </p>
                          <b className={styles['option-text']}>
                            {text.replaceThis}
                          </b>
                          <button
                            type="button"
                            onClick={() => handleReplacementRemove(index)}
                            className={styles['replace-button']}
                          >
                            <Image
                              src="/icons/CloseBlack.svg"
                              alt="delete"
                              objectFit="contain"
                              height={16}
                              width={16}
                            />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    aria-label="sparingly-text-list"
                    className={styles['options-grid']}
                  >
                    {SAfiltered?.map((text, index) => {
                      return (
                        <div
                          key={`$-${text || ''}-${index}`}
                          className={styles['sparingly-option-container']}
                        >
                          <p>Say</p>
                          <b>{text}</b>
                          <p>sparingly</p>
                          <button
                            type="button"
                            onClick={() => handleSparinglyRemove(index)}
                            className={styles['sparingly-button']}
                          >
                            <Image
                              src="/icons/CloseBlack.svg"
                              alt="delete"
                              objectFit="contain"
                              height={16}
                              width={16}
                            />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};
